import React, { useState, useEffect } from 'react';
import './Loading.css';

interface LoadingProps {
  onLoadingComplete?: () => void;
  is404?: boolean;
}

const DEBUG_MODE = process.env.REACT_APP_LOADING_DEBUG_MODE === 'true'


const Loading: React.FC<LoadingProps> = ({ onLoadingComplete, is404 = false }) => {
  const [progress, setProgress] = useState(0);
  const [loadingBox, setLoadingBox] = useState('');
  const [isCompleted, setIsCompleted] = useState(false);

  const somuniaText = `
.                                                                                  )GJ\`             
.                                                                                  !nr\`             
. '"=rr!;.       '"+//!_\`     _^\`."=r="'   '"=r/".   \`^_\`       '^~ \`^^ ."/rr+_     ^     '"/rr!".  
-SNM$Gm&NNA-  \`+qNHw4aG@Qu~  \`bBKNHk5HBNe_4ROZSmRBS- _BO_       ?B9 !RB5MH54SbNR|\` 7By\` _kN@GSSmRN4-
hBm~    ,6BX .2B5^\`    .+@Mr \`OB#"    !&BBm_    'wB5'_B$^       vBU !RBK;     ^NN1 7Bn\` RBi\`    .JNH
=RNu/^'\` \`\`  |BG         ;NR'\`OB"      <NB"      "Bd__B$^       vBU !RB'       CBY\`7Bn\` ..  \`',_"LMB
.'!i4HMgm[+\` 3BL         .#B,\`OB_      +MB\`      _Bd__B$^       iBU !RB        TBY\`7Bn\` ~JE&@RRHGqBB
^",   \`_!AB&.|Bm\`        "N@'\`OB_      +MB       _Bd__B$^      \`eBU !RB        TBY\`7Bn\`!N#?^-\`   !RB
&B5-     "RB_.4BO^\`    .1NR/ \`OB_      +MB       _Bd_'NN?\`    \`|NBU !RB        TBY\`7Bn\`ABV\`    \`"6BB
~ANRGS45KNg|  \`!6B@m4wqQNV^  \`OB_      +MB       _Bd_ "UBHk44EgRHBU !RB        TBY\`7Bn\`.AMHG4wmRB$MB

`;

  useEffect(() => {
    if (is404) {
      setProgress(100);
      setLoadingBox('');
      setIsCompleted(true);
      return;
    }

    const squares = '■'.repeat(20).split('');
    const updateInterval = 50;
    
    const getRandomDuration = () => Math.floor(Math.random() * (5000 - 1000 + 1)) + 1000;
    const transitionDuration = Math.floor(Math.random() * (600 - 100 + 1)) + 100;
    
    const updateProgress = () => {
      const randomDuration = getRandomDuration();
      const incrementPerStep = 100 / (randomDuration / updateInterval);
      
      setProgress(prevProgress => {
        const newProgress = Math.min(prevProgress + incrementPerStep, 100);
        
        const squareCount = Math.floor((newProgress / 100) * squares.length);
        setLoadingBox('■'.repeat(squareCount) + '□'.repeat(20 - squareCount));
        
        return newProgress;
      });
    };
    
    const interval = setInterval(() => {
      updateProgress();
      
      if (progress >= 100 && !isCompleted) {
        setIsCompleted(true);
        
        setTimeout(() => {
          clearInterval(interval);
          
          if (!DEBUG_MODE && onLoadingComplete) {
            setTimeout(() => {
              onLoadingComplete();
            }, 500);
          }
        }, transitionDuration);
      }
    }, updateInterval);
    
    return () => {
      clearInterval(interval);
    };
  }, [progress, onLoadingComplete, isCompleted, is404]);

  return (
    <div className="loading-container">
      <pre className="loading-ascii">
        {somuniaText}
      </pre>
      <pre className="loading-title">
        {is404 ? "404 Not found" : "// Loading Room"}
      </pre>
      <div className="loading-progress-container">
        {is404 ? (
          <div className="loading-percentage error">
            ERROR
          </div>
        ) : (
          <>
            <div className="loading-percentage">
              {Math.floor(progress)}%
            </div>
            <div className="loading-box">
              {loadingBox}
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default Loading;